import type { PropsWithChildren } from 'react';

import { styled } from '@mui/material/styles';

import { settings } from '@/_config';

import { Logo } from '../../logos';
import Card from '../../third_party/card';

import atpBg from './assets/atp-bg.jpg';
import swaBg from './assets/swa-bg.png';

const StyledMainWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundImage: `url(${settings.isSWA ? swaBg : atpBg})`,
  backgroundRepeat: settings.isSWA ? 'repeat' : 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: settings.isSWA ? '10px 10px' : 'cover',
  [theme.breakpoints.down('md')]: {
    backgroundImage: 'none',
  },
}));

type Props = PropsWithChildren<{
  className?: string;
}>;

function AuthWrapper({ children, className }: Props) {
  return (
    <StyledMainWrap className={className}>
      <Card
        padding="p-9"
        className="m-0 h-auto w-96 flex-col items-center justify-center overflow-y-auto border-divider shadow-md md:mx-auto md:my-5 md:min-h-0"
      >
        <div className="mb-12 mt-8">
          <Logo />
        </div>
        {children}
      </Card>
    </StyledMainWrap>
  );
}

export default AuthWrapper;
